import { PendingEverifyItemDto } from '@/features/pending_everify/infra/repositories/dto/PendingEverifyItemDto';
import { HttpClient } from '@/shared/infra/http/HttpClient';
import { PendingDhsSsaResult } from '../../application/domain/entities/PendingDhsSsaResult';
import { IPendingDhsSsaRepository } from '../../application/ports/outbound/IPendingDhsSsaRepository';
import { PendingDhsSsaMapper } from './mappers/PendingDhsSsaMapper';

export class ApiPendingDhsSsaRepository implements IPendingDhsSsaRepository {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * GET /e-verify/cases-listing?currentStatus=<status>
   *
   * The HttpClient returns ApiResponse<T> where T = the inner `data` value.
   * The outer { statusCode, message } envelope is already stripped by the
   * Axios response interceptor, so `response.data` here is the raw item array.
   */
  async fetchPendingDhsSsaCases(): Promise<PendingDhsSsaResult> {
    const response = await this.httpClient.getPaginated<PendingEverifyItemDto>(
      `/e-verify/case-summary?caseStatus=PENDING_REFERRAL&isUserActionRequired=true`
    );

    const items: PendingEverifyItemDto[] = response.data ?? [];
    return PendingDhsSsaMapper.toDomainList(items);
  }
}
